/* REL bulk length grid: totals, whole-cart wholesale tier preview, add all via /cart/add.js. No deps. */
(function () {
  'use strict';
  var T1 = 250000, T2 = 500000, R1 = 0.0769, R2 = 0.1429;
  function money(c) {
    var fmt = (window.REL && window.REL.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function dollars(c) { return '$' + Math.ceil(c / 100).toLocaleString('en-US'); }
  function grams(g) { return g >= 1000 ? (g / 1000).toFixed(2) + ' kg' : Math.round(g) + 'g'; }
  document.querySelectorAll('form[data-bulk]').forEach(function (form) {
    var ws = form.dataset.ws === 'true', cart = 0;
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-row]'));
    var $ = function (s) { return form.querySelector(s); };
    var btn = $('[data-bulk-add]'), status = $('[data-bulk-status]');
    var bar = form.querySelector('[data-bulk-bar]'), sumBox = $('.bulk-sum'), sumVisible = true, pieces = 0, barSub = '';
    var mq = window.matchMedia('(max-width: 749px)');
    function syncBar() {
      if (!bar) return;
      var r = sumBox.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      sumVisible = r.bottom > 0 && r.top < vh;
      var show = pieces > 0 && !sumVisible && mq.matches;
      bar.hidden = !show; document.body.classList.toggle('has-bulk-bar', show);
    }
    if (bar) {
      /* Bar lives on <body> so no transformed/overflow ancestor can trap position:fixed; button submits this form. */
      bar.querySelector('button').setAttribute('form', form.id);
      document.body.appendChild(bar);
      var tick = false;
      var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; syncBar(); }); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    var sels = Array.prototype.slice.call(form.querySelectorAll('[data-bg-opt]'));
    function selKey() { return sels.map(function (fs) { var c = fs.querySelector('input:checked'); return (c ? c.value : '') + '|'; }).join(''); }
    function applySel() {
      if (!sels.length) return;
      var key = selKey(), media = null;
      rows.forEach(function (r) { var on = r.dataset.opts === key; r.hidden = !on; if (on && !media && r.dataset.media) media = r.dataset.media; });
      sels.forEach(function (fs) { var c = fs.querySelector('input:checked'), l = fs.querySelector('[data-bg-cur]'); if (c && l) l.textContent = c.value; });
      var g = document.querySelector('[data-gallery]');
      if (media && g && g.querySelector('.gallery__slide[data-media-id="' + media + '"]')) {
        g.querySelectorAll('.gallery__slide,.gallery__thumb').forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === media); });
      }
    }
    function render() {
      var pcs = 0, sub = 0, wt = 0;
      rows.forEach(function (r) {
        var i = r.querySelector('.qty__input'), q = i ? Math.max(0, parseInt(i.value, 10) || 0) : 0;
        pcs += q; sub += q * +r.dataset.price; wt += q * +r.dataset.grams;
        r.classList.toggle('on', q > 0);
      });
      var total = cart + sub, rate = ws ? (total >= T2 ? R2 : total >= T1 ? R1 : 0) : 0;
      rows.forEach(function (r) {
        var p = +r.dataset.price, c = r.querySelector('[data-pr]');
        c.innerHTML = rate && !r.classList.contains('off') ? '<s>' + money(p) + '</s><span class="np">' + money(Math.round(p * (1 - rate))) + '</span>' : money(p);
      });
      $('[data-pcs]').textContent = pcs;
      if (sels.length === 1) {
        sels[0].querySelectorAll('input').forEach(function (inp) {
          var n = 0;
          rows.forEach(function (r) { var i = r.querySelector('.qty__input'); if (i && r.dataset.opts === inp.value + '|') n += parseInt(i.value, 10) || 0; });
          var ct = inp.nextElementSibling && inp.nextElementSibling.querySelector('[data-bg-ct]'); if (ct) ct.textContent = n ? '(' + n + ')' : '';
        });
      }
      $('[data-wt]').textContent = grams(wt);
      var ds = Math.round(sub * (1 - rate)), save = $('[data-save]');
      $('[data-sub]').innerHTML = rate && sub ? '<s class="sub-old">' + money(sub) + '</s> ' + money(ds) : money(sub);
      save.hidden = !(rate && sub);
      if (rate && sub) save.textContent = 'You save ' + money(sub - ds) + ' (' + (rate * 100).toFixed(2) + '% off)';
      btn.disabled = pcs === 0;
      pieces = pcs;
      if (bar) { bar.querySelector('[data-bar-text]').textContent = pcs + ' pcs \u00b7 ' + money(rate ? ds : sub); bar.querySelector('button').disabled = pcs === 0; syncBar(); }
      if (!ws) return;
      var t = total >= T2 ? '<b>14.29% off unlocked</b>'
        : total >= T1 ? 'Add <b>' + dollars(T2 - total) + '</b> more to unlock 14.29% off <span>(7.69% applied)</span>'
        : 'Add <b>' + dollars(T1 - total) + '</b> more to unlock 7.69% off';
      if (cart > 0) t += '<span class="tier-cart">Includes ' + money(cart) + ' already in your cart</span>';
      $('[data-tier]').innerHTML = t;
    }
    function loadCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) {
          cart = c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
          render();
        }).catch(render);
    }
    form.addEventListener('input', render);
    form.addEventListener('change', function (e) { if (e.target.closest('[data-bg-opt]')) applySel(); render(); });
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var items = [];
      rows.forEach(function (r) {
        var i = r.querySelector('.qty__input'), id = r.querySelector('input[type=hidden]'), q = i ? parseInt(i.value, 10) || 0 : 0;
        if (q > 0 && id) items.push({ id: +id.value, quantity: q });
      });
      if (!items.length) return;
      btn.disabled = true; status.hidden = false; status.className = 'add-status'; status.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { status.className = 'add-status is-error'; status.textContent = res.j.description || res.j.message || 'Could not add to order.'; btn.disabled = false; return; }
          var n = items.reduce(function (a, x) { return a + x.quantity; }, 0);
          status.textContent = 'Added ' + n + ' piece' + (n === 1 ? '' : 's') + ' \u2014 ';
          var a = document.createElement('a'); a.className = 'link-strong'; a.href = '/cart'; a.textContent = 'View cart'; status.appendChild(a);
          form.querySelectorAll('.qty__input').forEach(function (i) { i.value = 0; });
          return loadCart();
        })
        .catch(function () { btn.disabled = false; status.className = 'add-status is-error'; status.textContent = 'Network error. Please try again.'; });
    });
    applySel();
    render();
    if (ws) loadCart();
  });
})();
